import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  data: null,

};

export const previewSync = createAsyncThunk(
  "previewSync",
  async (configId) => {
    try {
      const response = await fetch(`/api/getPreviewSyncDetails/${configId}`, {
        method: "GET"
      });
      if (!response.ok) {
        throw new Error("Failed to fetch prview sync details");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const credentialsSlice = createSlice({
  name: "previewSync",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(previewSync.pending, (state) => {
        state.status = "Loading";
        state.message = null;
      })
      .addCase(previewSync.fulfilled, (state, action) => {
        state.status = "Success";
        state.data = action.payload.data;
      })
      .addCase(previewSync.rejected, (state, action) => {
        state.status = "error";
        state.message = action.error.message;
      });
  },
});

export default credentialsSlice.reducer;
